import { stringify } from "querystring";
import { SoCustomerInvoice } from "../customer-invoice.entity";
import { PlantInvoiceDto } from "../dto/plant-invoice.dto";
import { SaleOrderItems } from "../sale-order-items.entity";
import { SaleOrder } from "../sale-order.entitiy";

export class PlantInvoiceAdapter{
    public convertDtoToEntity(invoiceDto: PlantInvoiceDto, invNum:string):SoCustomerInvoice{
        console.log(invoiceDto);
        console.log("Adapter");
        const csInvoice = new SoCustomerInvoice();

        csInvoice.invoiceDate = invoiceDto.invoiceDate;
        csInvoice.etaDate = invoiceDto.etaDate;
        csInvoice.orderDate = invoiceDto.orderDate;
        csInvoice.totalAmount = invoiceDto.totalAmount;
        csInvoice.total_INR_amount = invoiceDto.total_INR_amount;
        csInvoice.isTaxApplicable = invoiceDto.isTaxApplicable;
        csInvoice.saleCommission = invoiceDto.saleCommission;
        csInvoice.insurance = invoiceDto.insurance;
        csInvoice.finNumber = invoiceDto.finNumber;
        csInvoice.endCustomerId = invoiceDto.endCustomerId;
        csInvoice.exchangeRate = invoiceDto.exchangeRate;
        csInvoice.freightCharges = invoiceDto.freightCharges;
        csInvoice.flightNumber = invoiceDto.flightNumber;
        csInvoice.unitId = invoiceDto.unitId;
        csInvoice.exporterId = invoiceDto.exporterId;
        csInvoice.portOfLoading = invoiceDto.portOfLoading;
        csInvoice.portOfDischarge = invoiceDto.portOfDischarge;
        csInvoice.customerId = invoiceDto.customerId;
        csInvoice.placeOfReceipt = invoiceDto.placeOfReceipt;
        csInvoice.invoiceCategory = invoiceDto.invoiceCategory;
        csInvoice.epcgLicenseNumber = invoiceDto.epcgLicenseNumber;
        csInvoice.epcgLicenseDate = invoiceDto.epcgLicenseDate;
        csInvoice.epcgFobValue = invoiceDto.epcgFobValue;
        csInvoice.exportObligation = invoiceDto.exportObligation;
        csInvoice.remarks = invoiceDto.remarks;

        if(invoiceDto.invoiceId){
            csInvoice.invoiceId = invoiceDto.invoiceId;
            csInvoice.updatedUser = invoiceDto.updatedUser;
        }else{
            // csInvoice.invoiceNumber = invNum;//need to uncomment from next financial year
            csInvoice.invoiceNumber = invoiceDto.invoiceNumber;
            csInvoice.createdUser = invoiceDto.createdUser;
        }

         csInvoice.saleOrderId = invoiceDto.saleOrderId;
         csInvoice.notifyPartyOne = invoiceDto.notifyPartyOne;
         csInvoice.notifyPartyTwo = invoiceDto.notifyPartyTwo;
         csInvoice.notifyPartyThree = invoiceDto.notifyPartyThree;
         csInvoice.finalDestination = invoiceDto.finalDestination;
         csInvoice.notifyPartyFour = invoiceDto.notifyPartyFour;

        //  const csInvItems :SaleOrderItems[] = [];
        //  for(const invoiceItems of invoiceDto.invoiceItemsInfo){
        //     const csInvItem = new SaleOrderItems();
        //     csInvItem.saleOrderItemId = invoiceItems.saleOrderItemId;
        //     csInvItem.revisedUnitPrice = invoiceItems.revisedUnitPrice;
        //     csInvItem.invoicedQty = invoiceItems.invoicedQuantity;
        //     csInvItems.push(csInvItem);
        //  }
        //  csInvoice.saleOrderInfo.saleOrderItemsInfo = csInvItems;

         console.log(csInvoice);
        return csInvoice;
    }
}